// Manual pages are authored in the Quill editor, so their content is HTML. The
// bulk drafts API stores a manual page as submission text, and the page card
// preview renders it as plain text — both need the markup gone. Block-level
// closers become newlines first so paragraphs don't run together.
const BLOCK_BREAK = /<\/(p|div|li|h[1-6]|tr|blockquote)>|<br\s*\/?>/gi;

// Dangerous tags that should be completely removed (including their content)
// to prevent XSS and ensure clean text extraction
const DANGEROUS_TAGS = /<(script|style|iframe|object|embed|applet|link|meta|noscript)[^>]*>.*?<\/\1>|<(script|style|iframe|object|embed|applet|link|meta|noscript)[^>]*\/>/gis;

export const htmlToPlainText = (html) => {
  if (!html) return '';

  // First, remove dangerous tags and their content to prevent XSS
  let sanitized = String(html).replace(DANGEROUS_TAGS, '');

  // Add newlines for block-level elements
  sanitized = sanitized.replace(BLOCK_BREAK, '$&\n');

  // Use DOMParser instead of innerHTML to prevent XSS attacks
  // DOMParser creates an inert document that doesn't execute scripts
  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitized, 'text/html');

  // Extract only text content, scripts won't execute
  return (doc.body.textContent || doc.body.innerText || '').trim();
};
